import axios from 'axios'
import authHeader from './authHeader'
import url from './url'
import store from '@/store/index.js'

const URL = url.lmsUrl
const OnboardingUrl = url.currentUrl
const reports = url.reportUrl
const backend = url.backendUrl

console.log('backend: ' + backend)

class LenderService {
    async getVirtualAccountInfo () {
        const response = await axios.get(URL + '/v1/virtual-account-info', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getLenderPortfoliosInfo () {
        const response = await axios.get(URL + '/v1/lender-portfolios-info', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getLenderInvestmentDetails () {
        const response = await axios.get(URL + '/v1/cumulative-chart', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getLenderPendingPayments () {
        const response = await axios.get(URL + '/v1/transactions-pending', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getLenderTransactions (query) {
        const response = await axios.get(URL + '/v1/transactions?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async payInvestmentPortfolio (payload) {
        const response = await axios.post(URL + '/v1/investment-portfolio-trigger', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async payInvestmentIncomePortfolio (payload) {
        const response = await axios.post(URL + '/v1/investment-income-portfolio-trigger', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
                // : process.env.VUE_APP_ID
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async editPortfolio (payload) {
        const response = await axios.patch(URL + '/v1/investment-portfolio', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async checkCreatedPortfolioExists () {
        const response = await axios.get(URL + '/v1/created-portfolios-status', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getVirtualAccount () {
        const response = await axios.get(URL + '/v1/virtual-account', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getAllAvailableLoans () {
        const response = await axios.get(URL + '/v1/manual-loans', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getLenderLoans () {
        const response = await axios.get(URL + '/v1/lender-loans', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getLenderLoansV2 (query) {
        const response = await axios.get(URL + '/v2/lender-loans?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getApr () {
        const response = await axios.get(URL + '/v1/lender-apr', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async manualInvest (payload) {
        const response = await axios.post(URL + '/v1/manual-investment', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getMaskedBankAccountInfo () {
        const response = await axios.get(URL + '/v1/masked/bank-account', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async withdrawMoney (payload) {
        const response = await axios.post(URL + '/v1/withdrawal/lender', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async addNomineeDetails (payload) {
        const response = await axios.post(URL + '/v1/nominee-details', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getUserNomineeData () {
        const response = await axios.get(URL + '/v1/get-nominee-details', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async editNomineeDetails (payload) {
        const response = await axios.patch(URL + '/v1/edit-nominee-details', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getIfscCode (query) {
        const response = await axios.get('https://ifsc.razorpay.com/' + query).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async updateCustomerMetaData (payload) {
        const response = await axios.patch(URL + '/v1/update-bank-meta-data', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            return err.response
        })
        return response
    }

    async getLenderOnboardingInfo () {
        const response = await axios.get(OnboardingUrl + '/v1/lender', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getMainDashboardData () {
        const response = await axios.get(URL + '/v1/user-data-dashboard', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getReferralData (query) {
        const response = await axios.get(URL + '/v1/referral-data-dashboard?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getPortfolioData () {
        const response = await axios.get(URL + '/v1/portfolio-data', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getGrowthTransactionData (query) {
        const response = await axios.get(URL + '/v1/growth-transaction-data?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getIncomeTransactionData (query) {
        const response = await axios.get(URL + '/v1/income-transaction-data?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getEarningsData () {
        const response = await axios.get(URL + '/v1/plans-earnings-data', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getExpectedEarningsData (query) {
        const response = await axios.get(URL + '/v1/expected-earnings-data?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getGrowthEarningsData (query) {
        const response = await axios.get(URL + '/v1/growth-earnings-data?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async lenderPhoneUpdateVerify (payload) {
        const response = await axios.patch(OnboardingUrl + '/v1/phone-verify', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getIncomeEarningsData (query) {
        const response = await axios.get(URL + '/v1/income-earnings-data?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async lenderPhoneUpdate (payload) {
        const response = await axios.patch(OnboardingUrl + '/v1/phone-init', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getFirstExpectedEarnings (query) {
        const response = await axios.get(URL + '/v1/first-expected-earnings?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async graphInvestmentData (query) {
        const response = await axios.get(URL + '/v1/graph-investment-data?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async incomeExpectedGraphData (query) {
        const response = await axios.get(URL + '/v1/income-graph-earnings-expected?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async growthExpectedGraphData (query) {
        const response = await axios.get(URL + '/v1/growth-graph-earnings-expected?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async growthGraphData (query) {
        const response = await axios.get(URL + '/v1/growth-graph-earnings?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async incomeGraphData (query) {
        const response = await axios.get(URL + '/v1/income-graph-earnings?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async checkIfPortfolioExists (query) {
        const response = await axios.get(URL + '/v1/check-existing-portfolio?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async createNewPortfolio (payload) {
        const response = await axios.post(URL + '/v1/create-new-portfolio?', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async earningsSummaryData () {
        const response = await axios.get(URL + '/v1/earnings-summary', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getWithdrawalPortfolios () {
        const response = await axios.get(URL + '/v2/portfolios/withdrawal', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getWithdrawalSummary (queryString) {
        const response = await axios.get(URL + '/v2/portfolio/withdrawal?' + queryString, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async sendPortfolioWithdrawalRequest (payload) {
        const response = await axios.post(URL + '/v2/portfolio/lender/withdraw-init', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getPendingWithdrawals () {
        const response = await axios.get(URL + '/v1/portfolios/pending-withdrawal', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async checkActiveWithdrawal () {
        const response = await axios.get(URL + '/v1/portfolios/is-active', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async investmentPlanData (query) {
        const response = await axios.get(URL + '/v1/investment-amount-plan?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async sendLockedPortfolioWithdrawalRequest (payload) {
        const response = await axios.post(URL + '/v1/portfolio/lender/locked-withdraw-init', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getLenderEarningReportPDF (query) {
        const response = await axios.get(reports + '/v3/lender-earning-report-pdf?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-',
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getLenderLoanReportPDF (query) {
        const response = await axios.get(reports + '/v3/lender-loan-report-pdf?' + query, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-',
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getBankAccounts () {
        const response = await axios.get(URL + '/v1/lender/bankAccounts', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async addBankAccount (payload) {
        const response = await axios.post(URL + '/v1/lender/bankAccount', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async deleteBankAccount (payload) {
        const response = await axios.patch(URL + '/v1/lender/delete-bankAccount', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async makePrimaryBankAccount (payload) {
        const response = await axios.patch(URL + '/v1/lender/bankAccount', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getSystemConfiguration () {
        const response = await axios.get(backend + '/v3/get-system-configuration', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async getMonthlyInvestmentAmount () {
        const response = await axios.get(URL + '/v1/monthly-investment-amount', {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async lenderEmailUpdateVerify (payload) {
        const response = await axios.patch(OnboardingUrl + '/v1/email-verify', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async lenderEmailUpdate (payload) {
        const response = await axios.patch(OnboardingUrl + '/v1/email-init', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }

    async cancelWithdrawalRequest (payload) {
        const response = await axios.post(URL + '/v2/portfolios/withdrawal/cancel', payload, {
            headers: {
                Authorization: 'Bearer ' + authHeader(),
                'x-application-key': 'hCQEWZNI-744A9C8E458A9-'
            }
        }).then((res) => {
            return res
        }).catch(err => {
            if (err.response.status === 401) {
                store.commit('setSessionOver')
            }
            return err.response
        })
        return response
    }
}

export default new LenderService()
